import { Box } from '@wix/design-system';
import {
  Faq,
  NonBlockerWrapper,
  PageFooter,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { HeaderBanner } from '../../components/HeaderBanner';
import { CycleSection } from '../../components/CycleSection';

export const SelectCyclePage = () => {
  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      paddingBottom="SP6"
      boxSizing="border-box"
    >
      <HeaderBanner />
      <Box
        margin="0 auto"
        direction="vertical"
        width="100%"
        align="center"
        padding="0px SP6"
        boxSizing="border-box"
      >
        <CycleSection />
        <Box marginTop="SP7" width="100%">
          <NonBlockerWrapper componentName="Faq">
            <Faq />
          </NonBlockerWrapper>
        </Box>
        <PageFooter />
      </Box>
    </Box>
  );
};
